export default "__VITE_ASSET__80b921ca__"